import { render } from "./approval-result-not-found.vue?vue&type=template&id=4f02f6e7"
const script = {}

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__